__turbopack_context__.v({
  "card": "CategoryCard-module-scss-module__JQC_nG__card",
  "colored-background": "CategoryCard-module-scss-module__JQC_nG__colored-background",
  "img-wrapper": "CategoryCard-module-scss-module__JQC_nG__img-wrapper",
  "out-of-bounds-box": "CategoryCard-module-scss-module__JQC_nG__out-of-bounds-box",
});
